import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
// import { SendFeed } from 'src/actions/feedback'
import Button from 'src/components/atoms/Button'
import Page from 'src/components/layouts/Page'
import InputWrap from 'src/components/molecules/InputWrap'
import css from './Support.module.scss'
import { useSelector } from 'react-redux'
import { clearState, sendFeedback } from 'src/slices/info'
import { handleStatus } from 'src/slices/utils'

export default function Support(params) {
	const dispatch = useDispatch()
	const [message, setMessage] = useState()
	const { status } = useSelector(state => state.info)

	useEffect(
		() =>
			handleStatus(status.sendFeedback, () => dispatch(clearState(status.sendFeedback)), {
				isSuccess: { callback: () => setMessage('') },
			}),
		[status.sendFeedback]
	)
	const handleMessage = () => {
		dispatch(sendFeedback(message))
	}
	return (
		<Page>
			<div className={css['page']}>
				<InputWrap
					label='Message'
					component={
						<textarea
							value={message}
							onChange={e => setMessage(e.target.value)}
						/>
					}
					helpText='  We will be reaching out to you through email within the next
                    24 hours.'
				/>
				<Button
					label='Submit'
					color='emerald'
					style={{
						width: 'max-content',
						alignSelf: 'end',
					}}
					action={handleMessage}
				/>
			</div>
		</Page>
	)
}
